/* Sales-unit menus initialize independently of older inline theme scripts. */
(() => {
  if (window.asmSalesUnitsReady) return;
  window.asmSalesUnitsReady = true;
  let menuId = 0;
  const selector = 'select[aria-label="Satış vahidi"],select[aria-label="Ədəd və ya qutu seçimi"],select[aria-label="Sifariş növü"],select[data-asm-sales-unit]';
  const clean = text => (text || '').trim().replace('Ədəd(', 'Ədəd (').replace('Qutu(', 'Qutu (');
  const close = wrapper => {
    wrapper.classList.remove('is-open');
    wrapper.querySelector('.asm-premium-unit__trigger')?.setAttribute('aria-expanded', 'false');
  };
  window.asmPremiumUnits = (scope = document) => {
    scope.querySelectorAll(selector).forEach(select => {
      if (select.closest('.asm-premium-unit')) return;
      const bounds = select.getBoundingClientRect();
      const wrapper = document.createElement('div');
      wrapper.className = 'asm-premium-unit';
      wrapper.style.width = `${Math.max(bounds.width, 108)}px`;
      wrapper.style.height = `${Math.max(bounds.height, 28)}px`;
      select.before(wrapper);
      wrapper.append(select);
      select.dataset.asmPremiumUnit = '1';
      select.setAttribute('data-asm-native', '');
      select.tabIndex = -1;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'asm-premium-unit__trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', 'Satış vahidi');
      trigger.innerHTML = '<span></span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 10 5 5 5-5"/></svg>';
      const menu = document.createElement('div');
      menu.className = 'asm-premium-unit__menu';
      menu.id = `asm-unit-menu-${++menuId}`;
      menu.setAttribute('role', 'listbox');
      menu.setAttribute('aria-label', 'Satış vahidi');
      trigger.setAttribute('aria-controls', menu.id);
      const sync = () => {
        trigger.disabled = select.disabled;
        trigger.querySelector('span').textContent = clean(select.selectedOptions[0]?.textContent);
        menu.replaceChildren(...Array.from(select.options, (option, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'asm-premium-unit__option';
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', String(index === select.selectedIndex));
          button.textContent = clean(option.textContent);
          button.disabled = option.disabled;
          button.addEventListener('click', () => {
            if (select.disabled || option.disabled) return;
            select.selectedIndex = index;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            close(wrapper);
            if (wrapper.isConnected) trigger.focus({ preventScroll: true });
          });
          return button;
        }));
      };
      const open = () => {
        if (select.disabled) return;
        document.querySelectorAll('.asm-premium-unit.is-open').forEach(close);
        sync();
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      };
      trigger.addEventListener('click', () => wrapper.classList.contains('is-open') ? close(wrapper) : open());
      trigger.addEventListener('keydown', event => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        event.preventDefault();
        open();
        (menu.querySelector('[aria-selected="true"]:not(:disabled)') || menu.querySelector('button:not(:disabled)'))?.focus();
      });
      menu.addEventListener('keydown', event => {
        const buttons = [...menu.querySelectorAll('button:not(:disabled)')];
        const index = buttons.indexOf(document.activeElement);
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next]?.focus();
        }
      });
      select.addEventListener('change', sync);
      wrapper.append(trigger, menu);
      sync();
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('.asm-premium-unit.is-open').forEach(wrapper => {
      if (!wrapper.contains(event.target)) close(wrapper);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.asm-premium-unit.is-open').forEach(wrapper => {
      const containsFocus = wrapper.contains(document.activeElement);
      close(wrapper);
      if (containsFocus) wrapper.querySelector('.asm-premium-unit__trigger')?.focus({ preventScroll: true });
    });
  });
  const ready = () => {
    window.asmPremiumUnits(document);
    const main = document.querySelector('main#MainContent');
    if (!main) return;
    new MutationObserver(changes => {
      for (const change of changes) {
        for (const node of change.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches(selector) || node.querySelector(selector)) window.asmPremiumUnits(node.parentElement || main);
        }
      }
    }).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
